import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import tw from "twin.macro";
import { usePostValue } from "..";
import { setUserDetailsStore } from "../../..";
import browserRoutes from "../../../../../common/browserRoutes";
import { DP } from "../../../../../common/types";

interface Props extends DP {}

const Author = (props: Props) => {
  const author = usePostValue((s) => s.post.createdBy);
	const navigate = useNavigate()

	const handleClick = () => {
		navigate('../' + browserRoutes.user(author.username))
	}

  return (
    <Button onClick={handleClick} className={props.className}>
      <Picture src={author.picture} />
      <Username>{author.username}</Username>
    </Button>
  );
};

const Button = styled.button(() => [
  tw`flex absolute bottom-0 left-0 ml-2 space-x-0.5 mb-2 items-center h-2`,
]);
const Username = styled.div(() => [tw``]);
const Picture = styled.img(() => [tw`h-full rounded-3xl`]);

export default styled(Author)``;
